import { ErrorMessage, Field, useFormikContext } from "formik";
import React, { FC, InputHTMLAttributes, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

type FormValues = {
  [key: string]: any;
};

type Props = {
  name: string;
  label?: string;
  required?: boolean;
  type?: string;
  showPasswordToggle?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

const InputField: FC<Props> = ({
  name,
  label,
  required,
  type = "text",
  showPasswordToggle = false,
  ...rest
}) => {
  const { touched, errors }: { touched: FormValues; errors: FormValues } =
    useFormikContext<FormValues>();

  const [showPassword, setShowPassword] = useState(false);

  const inputType = showPasswordToggle
    ? showPassword
      ? "text"
      : "password"
    : type;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="fv-row mb-0">
      {label && (
        <label className={`fs-6 form-label${required ? " required" : ""}`}>
          {label}
        </label>
      )}
      <div className="position-relative">
        <Field
          type={inputType}
          name={name}
          className="form-control fs-12px form-control-lg"
          {...rest}
        />
        {showPasswordToggle && (
          <button
            type="button"
            className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-3 bg-transparent border-0"
            onClick={togglePasswordVisibility}
            style={{ zIndex: 5 }}
          >
            {showPassword ? (
              <AiOutlineEyeInvisible className="fs-3 text-gray-800" />
            ) : (
              <AiOutlineEye className="fs-3 text-gray-800" />
            )}
          </button>
        )}
      </div>
      {/* Show error only if the field is touched and has an error */}
      <div className="text-danger mt-0">
        {touched[name] && errors[name] && <ErrorMessage name={name} />}
      </div>
    </div>
  );
};

export default InputField;
